import { Check, Copy, Trash2, User2, X } from 'lucide-react';
import React, { useState } from 'react';
import { Button } from 'src/components/ui/button';
import { Table, TableBody, TableCell, TableHead, TableRow } from 'src/components/ui/table';
import { TableHeader } from 'src/components/ui/table';
import { useActiveClient } from 'src/redux/active-client/use-active-client';
import { ClientUser } from '../../types/client.types';
import { formatDate } from 'src/pages/billing/utils/billing-utils';
import BorderedSelect from 'src/components/form-new/bordered-select';
import { websiteUrl } from 'src/constants/config';
import { useGetClientInviteCodeQuery } from 'src/redux/organization/organization.endpoints';
import notificationService from 'src/services/notification/notification.service';
import { useDispatch } from 'react-redux';
import { useCreateClientUserMutation } from '../../endpoints/client.endpoints';

interface ManageClientUsersProps {
  showAddUser: boolean;
  showInviteUser: boolean;
  onInviteUser: (show: boolean) => void;
  onAddUser: (show: boolean) => void;
}

const ManageClientUsers: React.FC<ManageClientUsersProps> = ({ showAddUser, showInviteUser, onAddUser, onInviteUser }) => {
  const { activeClient } = useActiveClient();
  const [email, setEmail] = useState('');
  const [role, setRole] = useState('user');
  const [isAdminInvite, setIsAdminInvite] = useState(false);
  const dispatch = useDispatch();

  const [createClientUser, { isLoading: isLoadingCreateUser }] = useCreateClientUserMutation();

  const getStatus = (user: ClientUser) => {
    if (user.pending) {
      return 'Sent @ ' + formatDate(user.created_at);
    }
    return 'Active';
  };

  const getRole = (user: ClientUser) => {
    if (user.user.permissions.groups.includes('client_admin')) {
      return 'Admin';
    }
    return 'User';
  };

  const { data: invite, isLoading: loadingInvite } = useGetClientInviteCodeQuery({ clientId: activeClient?.ext_client_id ?? '', forAdmin: isAdminInvite }, { skip: !activeClient?.ext_client_id });
  const [copied, setCopied] = useState<boolean>(false);

  const buildInviteLink = (inviteCode: string) =>
    `${websiteUrl}/create-account?invite_code=${inviteCode}&registration_type=client`;

  const handleCopy = (link: string) => {
    navigator.clipboard.writeText(link);
    setCopied(true);
    notificationService.handleSuccess(null, dispatch, 'Invite link copied to clipboard');
    setTimeout(() => setCopied(false), 1500);
  };

  const sendInvite = () => {
    if (!activeClient?.ext_client_id) {
      notificationService.handleError(null, dispatch, 'No client selected');
      return;
    }

    createClientUser({
      clientId: activeClient.ext_client_id,
      email: email,
    }).then((response) => {
      if ('error' in response) {
        notificationService.handleError(null, dispatch, 'Error sending invite');
        return;
      }

      notificationService.handleSuccess(null, dispatch, 'Invite sent successfully');
    });
  };

  return (
    <div>
      {/* <div className='mt-4'> */}
      <Table className='overflow-visible border border-gray-201 rounded-lg'>
        <TableHeader className="sticky top-0 bg-white z-10 rounded-t-lg">
          <TableRow className="border-b border-gray-201 rounded-t-lg">
            <TableHead className='w-[3%] min-w-[30px] py-1.5' />
            <TableHead className="text-gray-600 py-1.5 w-[40%] min-w-[200px]">
              Email
            </TableHead>
            <TableHead className="text-gray-600 py-1.5 min-w-[150px]">
              Role
            </TableHead>
            <TableHead className="text-gray-600 py-1.5 min-w-[150px]">
              Status
            </TableHead>
            <TableHead className="text-gray-600 py-1.5 max-w-[40px] text-center">
              Actions
            </TableHead>
          </TableRow>
        </TableHeader>
        <TableBody className="rounded-lg overflow-visible">
          {/* {showAddUser ? (
            <TableRow className='border-b-4 border-green-500 bg-gray-200'>
              <TableCell className='p-2 border-r border-gray-201 py-6'>
                <Circle className='w-4 h-4 animate-pulse bg-green-501 rounded-full text-green-501' />
              </TableCell>
              <TableCell className='p-2 border-r border-gray-201'>
                <BorderedInput
                //   label='Email'
                  value={email}
                  placeholder='Enter User Email...'
                  className='w-full text-sm'
                  textClassName='text-sm text-gray-700'
                  onChange={(e) => setEmail(e.target.value)}
                />
              </TableCell>
              <TableCell className='p-2 border-r border-gray-201'>
                <BorderedSelect
                //   label='Role'
                  value={role || 'user'}
                  className='w-full text-sm'
                  textClassName='text-sm'
                  onChange={(e) => setRole(e.target.value)}
                  options={[
                    { label: 'Admin', value: 'admin' },
                    { label: 'User', value: 'user' },
                  ]}
                />
              </TableCell>
              <TableCell className='p-2 border-r border-gray-201'>
                Pending...
              </TableCell>
              <TableCell className='text-center max-w-[70px]'>
                <Button
                  variant='ghost'
                  className='text-gray-700 hover:bg-gray-201'
                  size='sm'
                  onClick={() => { onAddUser(false); setEmail(''); setRole(''); }}
                >
                  <X className='w-4 h-4' />
                </Button>
                <Button
                  variant='ghost'
                  className='text-gray-700 hover:bg-gray-201'
                  size='sm'
                  onClick={sendInvite}
                >
                  <SendHorizonal className='w-4 h-4' />
                </Button>
              </TableCell>
            </TableRow>
          ) : null} */}
          {showInviteUser ? (
            <TableRow className='border-b-4 border-green-500 bg-gray-200'>
              <TableCell
                colSpan={5}
                className='items-center gap-2'
              >
                <div className='flex flex-row items-center gap-2 py-4'>
                  {/* <Circle className='w-4 h-4 animate-pulse bg-green-501 rounded-full text-green-501' /> */}
                  <BorderedSelect
                    value={isAdminInvite ? 'admin' : 'user'}
                    label='Invite Type'
                    className='w-[100px] text-sm'
                    textClassName='text-sm'
                    onChange={(e) => setIsAdminInvite(e.target.value === 'admin')}
                    options={[
                      { label: 'Admin', value: 'admin' },
                      { label: 'User', value: 'user' },
                    ]}
                  />
                  <code className="break-all bg-white p-3 rounded text-xs flex-1 min-w-0 border border-gray-201">
                    {buildInviteLink(invite?.invite_code ?? '')}
                  </code>
                  <div>
                    <Button
                      variant='ghost'
                      className='text-gray-700 hover:bg-gray-201'
                      size='sm'
                      onClick={() => { onInviteUser(false); setIsAdminInvite(false); }}
                    >
                      <X className='w-4 h-4' />
                    </Button>
                    <Button
                      variant='ghost'
                      className='text-gray-700 hover:bg-gray-201'
                      size='sm'
                      onClick={() => handleCopy(buildInviteLink(invite?.invite_code ?? ''))}
                    >
                      {copied === true ? <Check className='w-4 h-4' /> : <Copy className='w-4 h-4' />}
                    </Button>
                  </div>
                </div>
              </TableCell>
            </TableRow>
          ) : null}

          {activeClient?.users.map((user) => (
            <TableRow
              key={user.id}
              className='border-b border-gray-201'
            >
              <TableCell className='p-2 border-r border-gray-201 py-6'>
                <div className='flex flex-row items-center gap-2'>
                  {user.pending ? <div className='size-2 rounded-full bg-blue-500' /> : <div className='size-2 rounded-full bg-green-501' />}
                </div>
              </TableCell>
              <TableCell className='p-2 border-r border-gray-201'>
                {user.email}
              </TableCell>
              <TableCell className='p-2 border-r border-gray-201'>
                {getRole(user)}
              </TableCell>
              <TableCell className='p-2 border-r border-gray-201'>
                {getStatus(user)}
              </TableCell>
              <TableCell className='text-right max-w-[40px] text-center'>
                <Button
                  className='text-gray-700 hover:bg-gray-201'
                  variant='ghost'
                  size='sm'
                >
                  <Trash2 className='w-4 h-4' />
                </Button>
              </TableCell>
            </TableRow>
          ))}
          {activeClient?.users.length === 0 && (
            <TableRow>
              <TableCell
                colSpan={5}
                className='p-8 font-light items-center justify-center w-full text-center'
              >
                <div className='flex flex-row items-center justify-center gap-2'>
                  <User2 className='w-4 h-4' />
                  No active users for client
                </div>
              </TableCell>
            </TableRow>
          )}
          <div />
        </TableBody>
      </Table>

    </div>
  );
};

export default ManageClientUsers;